'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlcoModal = exports.Basket = undefined;

var _Basket2 = require('./Basket');

var _Basket3 = _interopRequireDefault(_Basket2);

var _AlcoModal2 = require('./AlcoModal');

var _AlcoModal3 = _interopRequireDefault(_AlcoModal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Basket = _Basket3.default;
exports.AlcoModal = _AlcoModal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/index.js
// module id = 1621
// module chunks = 0